// extracted by mini-css-extract-plugin
var _1 = "RepositoryConfigEditor--ActionButton";
var _2 = "RepositoryConfigEditor--ActionButton";
var _3 = "RepositoryConfigEditor--formGroup";
var _4 = "RepositoryConfigEditor--holder";
export { _1 as "ActionButton", _2 as "actionButton", _3 as "formGroup", _4 as "holder" }
